import React from 'react'
import MovieListItemArthouse from './MovieListItemArthouse'
import MovieListItemStandard from './MovieListItemStandard'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { FRONT, THEME, TRANSLATION } from '../../constants/state'
import getData from '../../functions/getData'
import toJS from '../../hoc/toJS'

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT), 
    theme: getData(state, THEME),
    translation: getData(state, TRANSLATION),
})

const MovieListItem = ({
    itemData, 
    itemLink,
    itemDetailsOpen, 
    scrollToPosition, 
    id, 
    hideCinemaSelector,
    isMobile,
    itemsData, 
    isOverview, 
    translation,
    closingDetails, 
    showMobileMovieTimes, 
    toggleMovieDatesOnMobileView, 
    toggleMovieTimesOnMobileView, 
    openItemDetails, 
    dayFilters,
    closeItemDetails, 
    currentDateActive,
    displaySidebarRight,
    index,
    theme,
    displaySidebarRightSecond,
    isSingleMovie,
    performancePageOpen, 
    overviewFilterIgnoreOnPerformances,
    activePerformance, 
    onOpenPerformancePage, 
    onClosePerformancePage,
    currentBrowserWidth,
    queryStringValues,
    clusterCinemaActive,
    clusterCinemaOption,
    activeCinema,
    currentCinemaType,
    cinemaDataFront
}) => {

    const {
        stripe_appearance,
        program_overview_list_style,
    } = cinemaDataFront

    const {theme_colors} = theme

    return theme_colors === 'Arthouse' ? (
        <MovieListItemArthouse 
            itemData={itemData} 
            itemLink={itemLink}
            itemDetailsOpen={itemDetailsOpen} 
            scrollToPosition={scrollToPosition} 
            id={id} 
            index={index}
            hideCinemaSelector={hideCinemaSelector}
            isMobile={isMobile}
            itemsData={itemsData} 
            isOverview={isOverview} 
            translation={translation}
            verviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
            closingDetails={closingDetails} 
            showMobileMovieTimes={showMobileMovieTimes} 
            toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView} 
            openItemDetails={openItemDetails} 
            dayFilters={dayFilters}
            closeItemDetails={closeItemDetails} 
            currentDateActive={currentDateActive}
            displaySidebarRight={displaySidebarRight}
            theme={theme_colors}
            displaySidebarRightSecond={displaySidebarRightSecond}
            isSingleMovie={isSingleMovie}
            performancePageOpen={performancePageOpen} 
            stripeAppearance={stripe_appearance}
            activePerformance={activePerformance} 
            onOpenPerformancePage={onOpenPerformancePage} 
            onClosePerformancePage={onClosePerformancePage}
            currentBrowserWidth={currentBrowserWidth}
            queryStringValues={queryStringValues}
            clusterCinemaActive={clusterCinemaActive}
            clusterCinemaOption={clusterCinemaOption}
            activeCinema={activeCinema}
            currentCinemaType={currentCinemaType}
        />
    ) : (
        <MovieListItemStandard 
            itemData={itemData} 
            itemLink={itemLink}
            itemDetailsOpen={itemDetailsOpen} 
            scrollToPosition={scrollToPosition} 
            id={id} 
            index={index}
            hideCinemaSelector={hideCinemaSelector}
            isMobile={isMobile}
            itemsData={itemsData} 
            isOverview={isOverview} 
            translation={translation}
            closingDetails={closingDetails} 
            verviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
            showMobileMovieTimes={showMobileMovieTimes} 
            toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView} 
            toggleMovieTimesOnMobileView={toggleMovieTimesOnMobileView} 
            openItemDetails={openItemDetails} 
            dayFilters={dayFilters}
            closeItemDetails={closeItemDetails} 
            currentDateActive={currentDateActive}
            displaySidebarRight={displaySidebarRight}
            programOverviewListStyle={program_overview_list_style}
            theme={theme_colors}
            displaySidebarRightSecond={displaySidebarRightSecond}
            isSingleMovie={isSingleMovie}
            performancePageOpen={performancePageOpen} 
            activePerformance={activePerformance} 
            onOpenPerformancePage={onOpenPerformancePage} 
            onClosePerformancePage={onClosePerformancePage}
            currentBrowserWidth={currentBrowserWidth}
            queryStringValues={queryStringValues}
            clusterCinemaActive={clusterCinemaActive}
            clusterCinemaOption={clusterCinemaOption}
            activeCinema={activeCinema}
            currentCinemaType={currentCinemaType}
        />
    )

}
export default compose(
    connect(mapStateToProps, null),
    toJS()
)(MovieListItem)